import React from "react";
import { Badge } from "@commonsku/design-system";

export interface AutomationStatusBadgeProps {
    status: string;
}

const AutomationStatusBadge = ({ status }: AutomationStatusBadgeProps) => {
    return (
        <Badge
            size="xs"
            variant="subtle"
            colorPalette={status === "Active" ? "success" : "neutral"}
        >      {status}
        </Badge>
    );
};

export default AutomationStatusBadge;
